import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { CodeTable } from '../../../../core/model/v2/code-table';
import { Patient } from '../../../../core/models/patient/patient';
import { PatientAddress } from '../../../../core/models/patient/patientAddress';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { CommonService } from '../../../../core/services/v2/common.service';
import { UserService } from '../../../../core/services/v2/user.service';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';
import * as _ from 'lodash';
import { UtilsService } from '../../../../core/services/v2/utils.service';

@Component({
  selector: 'app-patient-address-edit',
  templateUrl: './patient-address-edit.component.html',
  styleUrls: ['./patient-address-edit.component.scss']
})
export class PatientAddressEditComponent implements OnInit {
  @Input() sectionName: string;
  @Input() addresses: PatientAddress[];
  @Output() addressesChange = new EventEmitter<PatientAddress[]>();
  @Output() toggleEvent = new EventEmitter();

  userId: number;

  statesCodes: CodeTable;

  homeAddress: PatientAddress = new PatientAddress();
  previousAddress: PatientAddress = new PatientAddress();
  mailAddress: PatientAddress = new PatientAddress();
  billingAddress: PatientAddress = new PatientAddress();

  billAddressSameAsMailing = false;
  billAddressSameAsHome = false;
  mailAddressSameAsHome = false;
  constructor(
    private patientService: PatientService,
    private userService: UserService,
    private commonService: CommonService,
    private utils: UtilsService,
    private loaderService: WindowLoaderService) { }

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.userId = userDetails.id;
      },
      (error) => { console.error(error); }
    );
    this.loadCodes();

    this.populateAddresses();
  }

  cancel() {
    this.toggleEvent.emit();
  }

  loadCodes() {

    this.statesCodes = this.commonService.getItemCodesFiltered('STATE');
  }

  filterAddressOfType(type) {
    return this.addresses.filter(x => x.type === type && x.active);
  }

  populateAddresses() {
    if (this.addresses && this.addresses.length > 0) {
      this.addresses = this.addresses.filter(x => x.active);
      for (let i = 0; i < this.addresses.length; i++) {
        const value = this.addresses[i];
        if (value.type == 'HOME') {
          this.homeAddress = _.cloneDeep(value);
          if (value.isBilling) {
            this.billingSameAsHomeAddress(true);
          }
          if (value.isMailing) {
            this.mailSameAsHomeAddress(true);
          }
        }
        else if (value.type == 'MAILING') {
          this.mailAddress = _.cloneDeep(value);
          if (value.isBilling) {
            this.billingSameAsMailingAddress(true);
          }
        }
        else if (value.type == 'BILLING') {
          this.billingAddress = _.cloneDeep(value);
        }
      }
    }
  }

  mailSameAsHomeAddress(change: boolean) {
    //this.mailAddressSameAsHome = change;
    //this.homeAddress.isMailing = change;
    if (change) {
      const addr = _.cloneDeep(this.homeAddress);
      this.mailAddress.line = addr.line;
      this.mailAddress.line2 = addr.line2;
      this.mailAddress.city = addr.city;
      this.mailAddress.state = addr.state;
      this.mailAddress.zipCode = addr.zipCode;
      this.mailAddress.county = addr.county;
      this.mailAddress.country = addr.country;

      if (this.mailAddress.isBilling)
        this.billingSameAsHomeAddress(true);
    }

    if (this.mailAddress.isBilling) {
      const addr = _.cloneDeep(this.mailAddress);
      this.homeAddress.isBilling = false;
      this.billingAddress.line = addr.line;
      this.billingAddress.line2 = addr.line2;
      this.billingAddress.city = addr.city;
      this.billingAddress.state = addr.state;
      this.billingAddress.zipCode = addr.zipCode;
      this.billingAddress.county = addr.county;
      this.billingAddress.country = addr.country;
    }
  }

  billingSameAsHomeAddress(change: boolean) {
    //this.billAddressSameAsHome = change;
    if (change) {
      //this.billAddressSameAsMailing = !change;
      this.mailAddress.isBilling = false;
      const addr = _.cloneDeep(this.homeAddress);

      //this.homeAddress.isBilling = true;
      this.billingAddress.line = addr.line;
      this.billingAddress.line2 = addr.line2;
      this.billingAddress.city = addr.city;
      this.billingAddress.state = addr.state;
      this.billingAddress.zipCode = addr.zipCode;
      this.billingAddress.county = addr.county;
      this.billingAddress.country = addr.country;
    }
  }

  billingSameAsMailingAddress(change: boolean) {
    //this.billAddressSameAsMailing = change;
    if (change) {
      this.homeAddress.isBilling = false;
      //this.billAddressSameAsHome = !change;

      const addr = _.cloneDeep(this.mailAddress);

      //this.mailAddress.isBilling = true;
      this.billingAddress.line = addr.line;
      this.billingAddress.line2 = addr.line2;
      this.billingAddress.city = addr.city;
      this.billingAddress.state = addr.state;
      this.billingAddress.zipCode = addr.zipCode;
      this.billingAddress.county = addr.county;
      this.billingAddress.country = addr.country;
    }
  }

  saveAddresses() {

    var modifiedAddress: PatientAddress[] = [];
    if (this.homeAddress.isMailing) {
      this.mailSameAsHomeAddress(true);
    }
    if (this.homeAddress.isBilling) {
      this.billingSameAsHomeAddress(true);
    }
    else if (this.mailAddress.isBilling) {
      this.billingSameAsMailingAddress(true);
    }
    if (!this.billingAddress.userId) {
      this.billingAddress.userId = this.userId;
    }
    if (!this.mailAddress.userId) {
      this.mailAddress.userId = this.userId;
    }
    if (!this.homeAddress.userId) {
      this.homeAddress.userId = this.userId;
    }

    if (this.homeAddress) {
      this.homeAddress.type = 'HOME';
      modifiedAddress.push(this.homeAddress);
    }
    if (this.mailAddress) {
      this.mailAddress.type = 'MAILING';
      modifiedAddress.push(this.mailAddress);
    }
    if (this.billingAddress) {
      this.billingAddress.type = 'BILLING';
      modifiedAddress.push(this.billingAddress);
    }

    this.loaderService.blockWithLoader(this.patientService.updatePatientAddressDetails(modifiedAddress)).subscribe(
      (res) => {
        if (res['isSuccess']) {
          this.toggleEvent.emit();
        } else {
          console.error(res);
        }
      },
      (error) => { console.error(error); }
    );
  }
}
